<template>
  <div>
    <div>
      <h2>轮播图配置</h2>
      <el-form ref="form" :model="editForm" label-width="100px">
        <el-form-item label="高度(px)">
          <el-input-number
            :min="1"
            placeholder=""
            v-model.number="editForm.height"
            @change="changeStyle('height')"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="宽度(px)">
          <el-input-number
            :max="1200"
            :min="1"
            v-model.number="editForm.width"
            @change="changeStyle('width')"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="上外边距(px)">
          <el-input-number
            :min="0"
            :max="400"
            v-model.number="editForm.marginTop"
            @change="changeStyle('marginTop')"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="左外边距(px)">
          <el-input-number
            :min="0"
            v-model.number="editForm.marginLeft"
            @change="changeStyle('marginLeft')"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="css补充">
          <el-input
            type="textarea"
            v-model="editForm.css"
            @blur="changeStyle(editForm.css)"
            :rows="4"
          ></el-input>
        </el-form-item>
        <!---------------------------- 轮播图属性 ---------------------------->
        <el-form-item label="轮播方向">
          <el-select
            v-model="editForm.direction"
            placeholder="请选择轮播方向"
            @change="changeStyle(editForm.direction)"
          >
            <el-option
              v-for="item in directionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自动播放">
          <el-select
            v-model="editForm.autoplay"
            placeholder="请选择自动播放"
            @change="changeStyle(editForm.autoplay)"
          >
            <el-option
              v-for="item in autoplayOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="指示器位置">
          <el-select
            v-model="editForm.indicatorPosition"
            placeholder="请选择指示器位置"
            @change="changeStyle(editForm.indicatorPosition)"
          >
            <el-option
              v-for="item in indicatorPosition"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">

        <el-button type="primary" @click="saveBtn(false)">保存模板</el-button>
        <el-button type="primary" @click="saveBtn(true)" v-if="templateId"
          >另存模板</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    templateId: String,
    templateDiv: Object,
    editForm: Object,
    goodsOptions: Array,
  },
  data() {
    return {
      directionOptions: [
        { value: "horizontal", label: "水平" },
        { value: "vertical", label: "垂直" },
      ],
      autoplayOptions: [
        { value: true, label: "开启" },
        { value: false, label: "关闭" },
      ],
      indicatorPosition: [
        { value: "inside", label: "内部" },
        { value: "outside", label: "外部" },
        { value: "none", label: "不显示" },
      ],
      typeOptions: [
        { value: "card", label: "卡片化" },
        { value: "", label: "正常" },
      ],
    };
  },
  methods: {
    //改变style
    changeStyle(val) {
      this.$emit("changeStyle", val);
    },
    saveBtn(bol) {
      this.$emit("saveBtn", bol);
    },
  },
};
</script>
<style scoped>
.footer {
  display: flex;
  padding: 40px 40px 0 40px;
  box-sizing: border-box;
  justify-content: space-around;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineTemplate/template/editCarousel.vue